import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getLeaderboard = async () => {
  const res = await axios.get(`${API}/leaderboard`);
  return res.data;
};

export const submitScore = async (name, score, wallet) => {
  const res = await axios.post(`${API}/leaderboard`, { name, score, wallet });
  return res.data;
};
